import { useState } from 'react';

export default function Services() {
  const [expandedCard, setExpandedCard] = useState(0);

  const services = [
    {
      title: '客製化燃點式企業團建',
      subtitle: '活動只是載體，改變才是真正產品',
      image: 'https://public.readdy.ai/ai/img_res/33cdab938fdd7af96d5b22ff9495dd9a.jpg',
      details: [
        '室內挑戰式團建',
        '戶外高強度團建',
        '室內＋戶外混合型團建',
        '主題團建（信任、協作、領導、責任、韌性）'
      ]
    },
    {
      title: '高績效團隊工作坊',
      subtitle: '把你們的真實問題搬進活動現場，直接練習',
      image: 'https://readdy.ai/api/search-image?query=professional%20business%20workshop%20with%20team%20members%20in%20discussion%20and%20collaboration%2C%20indoor%20conference%20room%20setting%20with%20natural%20lighting%2C%20people%20engaged%20in%20strategic%20planning%20and%20problem%20solving%2C%20modern%20office%20environment%2C%20professional%20photography%20showing%20active%20participation&width=1200&height=800&seq=service002&orientation=landscape',
      details: [
        '跨部門破牆協作',
        '衝突對話與修復',
        '高效溝通與回饋',
        '心理安全與責任感'
      ]
    },
    {
      title: '主管帶隊實戰團建',
      subtitle: '專為「壓力大、責任重、資源少」的主管設計',
      image: 'https://readdy.ai/api/search-image?query=leadership%20training%20session%20with%20managers%20and%20team%20leaders%20in%20action%2C%20professional%20development%20workshop%20with%20coaching%20and%20mentoring%20activities%2C%20indoor%20training%20facility%20with%20focused%20participants%2C%20high%20quality%20photography%20showing%20leadership%20skills%20practice&width=1200&height=800&seq=service003&orientation=landscape',
      details: [
        '如何帶人而不是命令人',
        '如何建立信任而不是恐懼',
        '如何激發主動而不是等待',
        '如何面對衝突而不是壓下去'
      ]
    }
  ];

  return (
    <section id="services" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex justify-between items-end mb-12">
          <div>
            <h2 className="text-5xl font-bold text-gray-900 mb-2" style={{ fontFamily: 'Noto Serif TC, serif' }}>
              我們的服務
            </h2>
            <p className="text-xl text-gray-600">Our Services</p>
          </div>
          <button className="bg-black text-white px-6 py-3 rounded-full font-medium hover:bg-orange-500 transition-all duration-300 flex items-center gap-2 whitespace-nowrap cursor-pointer">
            查看完整方案
            <i className="ri-arrow-right-line"></i>
          </button>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className={`relative rounded-3xl overflow-hidden cursor-pointer transition-all duration-500 ${
                expandedCard === index ? 'md:col-span-2' : 'md:col-span-1'
              }`}
              onMouseEnter={() => setExpandedCard(index)}
            >
              <div className="relative h-96 md:h-[500px]">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover transition-transform duration-500 hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-8">
                  <h3 className="text-3xl font-bold text-white mb-3">{service.title}</h3>
                  <p className="text-white/90 text-lg mb-4">{service.subtitle}</p>
                  {expandedCard === index && (
                    <ul className="space-y-2 mt-6">
                      {service.details.map((detail, idx) => (
                        <li key={idx} className="text-white/80 flex items-center gap-2">
                          <i className="ri-check-line text-orange-500"></i>
                          {detail}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
